export const SUBMIT_COSANNEXE_FORM = 'cosAnnexeForm/SUBMIT_COSANNEXE_FORM';